import React from 'react';
import TransferContent from './content';
import { TransferProvider } from 'contexts/transfer.context';
const TransferLayout = () => {
  return (
    <TransferProvider>
      <TransferContent />
    </TransferProvider>
  );
};

export default TransferLayout;
